// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__2npZW","logo":"Sidebar_logo__tzZTE","menu":"Sidebar_menu__IB9o+"};